export default __webpack_public_path__ + "static/media/Group9219.31b89925.svg";